var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 4.125H8.25C5.3625 4.125 3.09375 6.39375 3.09375 9.28125V28.875C3.09375 29.2875 3.3 29.5969 3.7125 29.8031C3.81562 29.9062 4.02187 29.9062 4.125 29.9062C4.33125 29.9062 4.64062 29.8031 4.84687 29.7C9.28125 25.7812 14.9531 23.7188 20.8313 23.7188H24.75C27.6375 23.7188 29.9062 21.45 29.9062 18.5625V9.28125C29.9062 6.39375 27.6375 4.125 24.75 4.125ZM14.4375 17.5312H11.3438C10.725 17.5312 10.3125 17.1188 10.3125 16.5C10.3125 15.8812 10.725 15.4688 11.3438 15.4688H14.4375C15.0563 15.4688 15.4688 15.8812 15.4688 16.5C15.4688 17.1188 15.0563 17.5312 14.4375 17.5312ZM17.5312 13.4062H11.3438C10.725 13.4062 10.3125 12.9938 10.3125 12.375C10.3125 11.7562 10.725 11.3438 11.3438 11.3438H17.5312C18.15 11.3438 18.5625 11.7562 18.5625 12.375C18.5625 12.9938 18.15 13.4062 17.5312 13.4062Z",
    fill: "#5F6C8E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.8a3042c11625fa38919a4792cc39c868.svg";
export { ForwardRef as ReactComponent };